<template>
  <div class="dtv">
    <div class="dtv-head">
      <div class="dtv-head-left">
        <div class="dtv-ico">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#F5B935" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
        </div>
        <div>
          <div class="dtv-title">Top VSLs da semana</div>
          <div class="dtv-sub">Ranqueadas por engajamento ponderado</div>
        </div>
      </div>
      <a href="#" class="dtv-ver" @click.prevent="goToAll">Ver todas →</a>
    </div>

    <div class="dtv-list">
      <div v-for="(vsl, i) in vsls" :key="i" class="dtv-row" @click="openVsl(vsl)">
        <!-- Thumbnail -->
        <div class="dtv-thumb">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        </div>
        <!-- Info -->
        <div class="dtv-info">
          <span class="dtv-name">{{ vsl.name }}</span>
          <div class="dtv-meta">
            <span class="dtv-chip">{{ vsl.type }}</span>
            <span class="dtv-dur mono">{{ vsl.duration }}</span>
            <span class="dtv-trend" :class="vsl.trendUp ? 'up' : vsl.trendUp === false ? 'dn' : 'flat'">
              {{ vsl.trendUp === true ? '▲' : vsl.trendUp === false ? '▼' : '→' }} {{ vsl.trend }}
            </span>
          </div>
          <div class="dtv-bar-wrap">
            <div class="dtv-bar" :style="{ width: vsl.barW }"></div>
          </div>
        </div>
        <!-- Stats -->
        <div class="dtv-stats">
          <div class="dtv-stat">
            <span class="dtv-stat-val mono">{{ vsl.views }}</span>
            <span class="dtv-stat-lbl">VIEWS</span>
          </div>
          <div class="dtv-stat">
            <span class="dtv-stat-val mono" :style="{ color: engColor(vsl.eng) }">{{ vsl.eng }}%</span>
            <span class="dtv-stat-lbl">ENG.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashTopVsls',
  props: {
    vsls: {
      type: Array,
      default: () => [
        { name: 'Pitch Curso Copy · v4.2 final',    type: 'VSL', duration: '12:48', trendUp: true,  trend: '218% esta semana', views: '847', eng: 73, barW: '92%' },
        { name: 'VSL Webinar Lançamento Abril',      type: 'WEB', duration: '42:12', trendUp: true,  trend: '44%',              views: '612', eng: 61, barW: '78%' },
        { name: 'Mentoria Tráfego Pago',             type: 'VSL', duration: '9:34',  trendUp: null,  trend: 'estável',          views: '498', eng: 52, barW: '62%' },
        { name: 'Landing Checkout Principal',        type: 'VSL', duration: '6:21',  trendUp: false, trend: '12%',              views: '387', eng: 38, barW: '48%' },
        { name: 'Prova Social · Depoimentos 2026',   type: 'VSL', duration: '3:44',  trendUp: true,  trend: '9%',               views: '300', eng: 41, barW: '38%' },
      ],
    },
  },
  methods: {
    navigate(target) {
      if (this.$router && typeof this.$router.push === 'function') {
        this.$router.push(target)
      } else if (typeof target === 'string') {
        window.location.href = target
      } else if (target && target.path) {
        window.location.href = target.path
      }
    },
    goToAll() {
      this.navigate({ name: 'Meus-Videos' })
    },
    openVsl(vsl) {
      if (vsl?.route) {
        this.navigate(vsl.route)
        return
      }
      if (vsl?.href) {
        window.open(vsl.href, '_blank', 'noopener')
        return
      }
      if (vsl?.id) {
        this.navigate(`/player/${vsl.id}`)
        return
      }
      this.navigate({ name: 'Meus-Videos' })
    },
    engColor(eng) {
      if (eng >= 65) return '#28C76F'
      if (eng >= 50) return '#F5B935'
      if (eng >= 35) return '#F08023'
      return '#FF5A6B'
    },
  },
}
</script>

<style>
.dtv {
  background: linear-gradient(180deg, rgba(22,29,43,.8), rgba(16,21,31,.9));
  border: 1px solid var(--wr-line-2);
  border-radius: 16px;
  padding: 22px;
  font-family: 'Inter', sans-serif;
  min-width: 0;
}
.dtv-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 20px; }
.dtv-head-left { display: flex; align-items: flex-start; gap: 10px; }
.dtv-ico { width: 32px; height: 32px; border-radius: 9px; background: rgba(245,185,53,.12); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.dtv-title { font-size: 14.5px; font-weight: 800; color: var(--wr-text); }
.dtv-sub { font-size: 12px; color: var(--wr-mute); margin-top: 2px; }
.dtv-ver { font-size: 13px; font-weight: 700; color: #F08023; text-decoration: none; white-space: nowrap; margin-top: 4px; }
.dtv-ver:hover { text-decoration: underline; }
.dtv-list { display: flex; flex-direction: column; gap: 4px; }
.dtv-row {
  display: grid;
  grid-template-columns: 48px 1fr auto;
  gap: 14px;
  align-items: center;
  padding: 10px 8px;
  border-radius: 10px;
  transition: background .15s;
  cursor: pointer;
}
.dtv-row:hover { background: rgba(255,255,255,.03); }
.dtv-thumb {
  width: 48px; height: 48px;
  border-radius: 8px;
  background: radial-gradient(ellipse at 40% 40%, rgba(232,106,16,.15), rgba(15,20,32,1));
  border: 1px solid var(--wr-line);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dtv-info { min-width: 0; }
.dtv-name { font-size: 13.5px; font-weight: 700; color: var(--wr-text); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; display: block; margin-bottom: 4px; }
.dtv-meta { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; flex-wrap: wrap; }
.dtv-chip { font-size: 10.5px; font-weight: 700; padding: 2px 7px; border-radius: 5px; background: rgba(255,255,255,.08); color: var(--wr-mute); }
.dtv-dur { font-family: 'JetBrains Mono', monospace; font-size: 12px; color: var(--wr-mute); }
.dtv-trend { font-size: 12px; font-weight: 600; }
.dtv-trend.up { color: #28C76F; }
.dtv-trend.dn { color: #FF5A6B; }
.dtv-trend.flat { color: var(--wr-mute); }
.dtv-bar-wrap { height: 6px; border-radius: 3px; background: rgba(255,255,255,.06); overflow: hidden; width: 80px; }
.dtv-bar { height: 100%; border-radius: 3px; background: linear-gradient(90deg, #E86A10, #F5B935); }
.dtv-stats { display: flex; flex-direction: column; gap: 4px; align-items: flex-end; flex-shrink: 0; }
.dtv-stat { display: flex; flex-direction: column; align-items: flex-end; gap: 1px; }
.dtv-stat-val { font-family: 'JetBrains Mono', monospace; font-size: 15px; font-weight: 700; color: var(--wr-text); font-variant-numeric: tabular-nums; }
.dtv-stat-lbl { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; color: var(--wr-dim); }
</style>
